import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/global.css'
import request from './utils/request'
import i18n from './i18n'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 兼容现有页面中的 this.$http 调用
Vue.prototype.$http = request

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
